import { DAYS_OF_WEEK } from '../state/constants/index'
import { ICoordinatesWithShortKeyDTO } from './google-map'
import { IOrganization } from './organization'
import { IProviderObject } from './provider'
import { IProviderProductObject } from './provider-product'
import { IServiceProgramObject } from './service-program'

export interface IServiceMetadata {
  fetching: boolean
  fetchingError: string
  processing: boolean
  processingError: string
  activeColumns: string[]
  edit: {
    serviceId?: string
  }
  archive: IServiceArchive
  restore: IServiceRestore
  total?: number
}
export interface IServiceStateFilters {
  organizationId?: string
  type?: string
  skip?: number
  take?: number
  orderBy?: string
  sort?: string
}
export interface IServiceArchive {
  serviceId?: string
}

export interface IServiceRestore {
  serviceId?: string
}

export interface IServiceFetchItemsResponse {
  services: { [key: string]: IServiceObject }
  servicePrograms: { [key: string]: IServiceProgramObject }
  total: number
}

export interface IServiceFetchItemResponse {
  services: { [key: string]: IServiceObject }
  servicePrograms: { [key: string]: IServiceProgramObject }
}

export interface IServiceObject {
  id: string
  name: string
  internalName?: string
  organization: IOrganization
  archived: boolean
  isAllDaysActive: boolean
  logo: string
  providers?: string[]
  providerProducts?: IProviderProductObject[]
  serviceDays: IWorkingHoursItem[]
  description?: string
  phoneNumber?: string
  serviceProgram?: string
  isMembershipRequired?: boolean
  tripLimit?: number
  isGroupRide?: boolean
  tripLimitDuration?: string
  viewOption?: string
  autoDispatch?: boolean
  signatureCollectionRequired?: boolean
  serviceOptions?: IServiceOptions[]
  ondemandGridePickupRadius?: number
  ondemandGrideDropoffRadius?: number
  scheduledGridePickupRadius?: number
  scheduledGrideDropoffRadius?: number
  scheduledGridePickupTime?: number
  scheduledGrideDropoffTime?: number
  allowGroupingDifferentProducts?: boolean
  notificationMessage?: string
  notificationOptions?: NotificationOptions[]
  onDemandTripReminder?: boolean
  scheduledTripReminder?: boolean
  willCallTripReminder?: boolean
  requestTimeoutDuration?: number
  allowMobileRequest?: boolean
  maxTravelDistance?: number
  rideReconfirmation?: number
  designatedHotspotsEnabled?: number
  hideService?: boolean
  notAllowedPCA?: boolean
  allowMultipleStop?: boolean
}

export interface IServiceCreateObject {
  name: string
  userId: string
  phoneNumber?: string
  internalName?: string
  organizationId: string
  serviceProgramId?: string
  description: string
  isMembershipRequired?: boolean
  tripLimit?: number
  tripLimitDuration?: string
  viewOption?: string
  autoDispatch?: boolean
  signatureCollectionRequired?: boolean
  serviceOptions?: IServiceOptions[]
  isGroupRide?: boolean
  maxTravelDistance?: number
  rideReconfirmation?: number
  designatedHotspotsEnabled?: number
  hideService?: boolean
  allowMultipleStop?: boolean
}

export interface IServiceUpdateObject {
  id: string
  name: string
  internalName?: string
  organizationId: string
  serviceProgramId?: string
  description: string
  isMembershipRequired?: boolean
  tripLimit?: number
  tripLimitDuration?: string
  viewOption?: string
  autoDispatch?: boolean
  signatureCollectionRequired?: boolean
  serviceOptions?: IServiceOptions[]
  isGroupRide?: boolean
  notificationMessage?: string
  notificationOptions?: NotificationOptions[]
  onDemandTripReminder?: boolean
  scheduledTripReminder?: boolean
  willCallTripReminder?: boolean
  requestTimeoutDuration?: number
  allowMobileRequest?: boolean
  maxTravelDistance?: number
  rideConfirmation?: number
  designatedHotspotsEnabled?: number
  hideService?: boolean
  allowMultipleStop?: boolean
}

export interface IServiceGroupRideRadiusUpdate {
  id: string
  ondemandGridePickupRadius: number
  ondemandGrideDropoffRadius: number
  scheduledGridePickupRadius: number
  scheduledGrideDropoffRadius: number
  scheduledGridePickupTime: number
  scheduledGrideDropoffTime: number
  allowGroupingDifferentProducts: boolean
}

export interface IServiceResponseObject {
  id: string
  name: string
  internalName: string
  organization: IOrganization
  providers: IProviderObject[]
  products: IProviderProductObject[]
  description: string
  isMembershipRequired: boolean
}

export interface IServiceProvider {
  provider: IProviderObject
  products?: IProviderProductObject[]
  allProviderProducts?: IProviderProductObject[]
}

export interface IServiceEditStep {
  name: string
  url: string
  title: string
  required: boolean
  completed: boolean
}

export interface IServiceEditStepData {
  position: number
  fetching: boolean
  fetchingError: string
  updating: boolean
  updatingError: string
  changed: boolean
}

export interface IServiceEditSteps {
  list: IServiceEditStep[]
  currentStep: IServiceEditStepData
}

export interface IServicePricingBreakdown {
  fare: number
  commission: number
  comissionFlat: number
  discountFlat: number
  discount: number
  stateTax: number
  federalTax: number
  freeAttendant: boolean
}

export interface ISimpleService {
  serviceId: string
  name: string
}

export interface IWorkingHoursItem {
  id: string
  from: string
  until: string
  days: DAYS_OF_WEEK[]
  serviceId?: string
}

export interface IHolidayItem {
  id: string
  serviceId?: number
  orgId: number
  date: Date
  from: string
  until: string
}
export interface IServicePricingType {
  id: string
  serviceId?: string
  orgId?: string
  riderType?: string
  description?: string
  fare: number
  isActive: boolean
}

export interface IServicePricingTypeObject {
  fares: IServicePricingType[]
}

export enum IServiceOptions {
  ON_DEMAND = 1,
  SCHEDULED = 2
}

export enum NotificationOptions {
  ON_DEMAND = 1,
  SCHEDULED = 2,
  WILL_CALL = 3
}

export interface IServiceLocationObject {
  id?: string
  city?: string
  country?: string
  fullAddress: string
  googlePlaceId: string
  coordinates: ICoordinatesWithShortKeyDTO
  note?: string
  placeName?: string
  phoneNumber?: string
  state?: string
  street?: string
  streetNumber?: string
  zip?: string
  modifying: boolean
  isNew?: boolean
  timeZone?: string
  unit?: string
  service?: IServiceObject
}

export interface ISelectOption {
  label: string
  value: string | undefined
}



// WEBPACK FOOTER //
// ./src/types/service.ts